const optimizerEn = {
	optimizerTable: 'Optimizer',
	optimizerEditForm: 'Optimizer',
	// Common fields
	name: 'Name',
	userGroup: 'User Group',
	type: 'Type',
	imputedValue: 'Imputed value',
	// Generic optimizer params
	maxiter: 'Max iterations',
	maxEpoch: 'Max epoch',
	initialTrustRadius: 'Initial trust radius',
	maxTrustRadius: 'Max trust radius',
	tol: 'Tol',
	eta: 'Eta',
	gtol: 'Gtol',
	ftol: 'Ftol',
	eps: 'Eps',
	norm: 'Norm',
	maxcor: 'Max corrections',
	maxfun: 'Max function evals',
	maxls: 'Max line searches',
	iters: 'Iters',
	method: 'Method',
	samplingMethod: 'Sampling Method',
	workers: 'Workers',
	c1: 'C1',
	c2: 'C2',
	xrtol: 'Xrtol',
	xtol: 'Xtol',
	rhobeg: 'Rhobeg',
	catol: 'Catol',
	// Random/Quadratic Restart
	localOptimizer: 'Local Optimizer',
	modelOptimizer: 'Model Optimizer',
	// legacy
	localSearchName: 'Local search name',
	// Particle Swarm
	maxIterationCount: 'Max iteration count',
	particleCount: 'Particle count',
	w: 'Inertia (w)',
	// SHGO
	n: 'N',
	// Dual Annealing
	initialTemp: 'Initial temperature',
	restartTempRatio: 'Restart temp ratio',
	visit: 'Visit parameter',
	accept: 'Accept parameter',
	// Differential Evolution
	strategy: 'Strategy',
	popsize: 'Population size',
	mutation: 'Mutation',
	recombination: 'Recombination',
	updating: 'Updating',
	init: 'Population initialization',
	// DIRECT
	fMinRtol: 'fMin relative tol',
	locallyBiased: 'Locally biased',
	volTol: 'Volume tolerance',
	// Nelder–Mead
	xatol: 'X tolerance',
	fatol: 'F tolerance',
	adaptive: 'Adaptive',
	// Truncated Newton
	offset: 'Offset',
	stepmx: 'Step max',
	accuracy: 'Accuracy',
	minfev: 'Min function evals',
	rescale: 'Rescale',
	// TrustNCG (camelCase-elve)
	barrierTol: 'Barrier tol',
	initialTrRadius: 'Initial trust-region radius',
	initialConstrPenalty: 'Initial constraint penalty',
	initialBarrierParameter: 'Initial barrier parameter',
	// Near-Exact Trust Krylov
	inexact: 'Inexact',
	// Bayesian Optimizer
	initialPoint: 'Initial point',
	iterations: 'Iterations',
	verbose: 'Verbose',
	randomState: 'Random state',
	// Grid Descent
	epsilon: 'Epsilon',
};

export default optimizerEn;